import http from '@/plugins/axios';

function getPublishedVal(published, unpublished) {
  if ((published && unpublished) || (published === null && unpublished === null)) {
    return ['unpublished', 'published'];
  } else if (published === true && unpublished === null) {
    return ['published'];
  } else if (published === null && unpublished === true) {
    return ['unpublished'];
  }
}

export default {
  getReviewsList: (
    { id, rowsPerPage, sortBy, descending, page, search, filterBy, published, unpublished },
    productId
  ) => {
    const filters = JSON.parse(JSON.stringify(filterBy));
    filters.published = getPublishedVal(published && unpublished) || filters.published;
    const params = {
      id: id,
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      order_direction: descending ? 'desc' : 'asc',
      search: search,
      filter_by: JSON.stringify(filters),
    };
    if (productId) {
      return http.get('/products/' + productId + '/reviews', { params }).then(res => res.data);
    } else {
      return http.get('/reviews', { params }).then(res => res.data);
    }
  },
  getReviewsListMultipleProducts: (
    { rowsPerPage, sortBy, descending, page, search, filterBy, published, unpublished },
    productIds
  ) => {
    const filters = JSON.parse(JSON.stringify(filterBy));
    filters.published = getPublishedVal(published && unpublished) || filters.published;
    const params = {
      product_ids: JSON.stringify(productIds),
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      order_direction: descending ? 'desc' : 'asc',
      search: search,
      filter_by: JSON.stringify(filters),
    };
    return http.get('/products-reviews', { params }).then(res => res.data);
  },
  postPublishReview: id => http.post('/reviews/' + id + '/publish', {}),
  postUnpublishReview: id => http.post('/reviews/' + id + '/unpublish', {}),
  postDeleteReview: id => http.post('/reviews/' + id + '/delete', {}),
  postDeleteComment: id => http.post('/reviews/' + id + '/delete-comment', {}),
  postHideReview: id => http.post('/reviews/' + id + '/hide', {}),
  postUnhideReview: id => http.post('/reviews/' + id + '/unhide', {}),
  postAddCarouselReview: id => http.post('/reviews/' + id + '/carousel-add', {}),
  postRemoveCarouselReview: id => http.post('/reviews/' + id + '/carousel-remove', {}),
  featureReviewForEmailMarketing: id =>
    http.post('/reviews/' + id + '/feature-review-for-email-marketing', {}),
  unfeatureReviewForEmailMarketing: id =>
    http.post('/reviews/' + id + '/unfeature-review-for-email-marketing', {}),
  incentivizeReview: id => http.post('/reviews/' + id + '/incentivize', {}),
  deactivateIncentivizeReview: id => http.post('/reviews/' + id + '/deactivate-incentivize', {}),
  postImageRotate: (reviewId, imageUrl) => {
    http.post('/reviews/' + reviewId + '/image-rotate', {
      image_url: imageUrl,
    });
  },
  postImageDelete: (reviewId, imageUrl) =>
    http.post('/reviews/' + reviewId + '/image-delete', {
      image_url: imageUrl,
    }),

  postImageMove: (reviewId, imageUrls) =>
    http.post('/reviews/' + reviewId + '/image-move', {
      image_urls: imageUrls,
    }),
  postVideoDelete: reviewId => http.post('/reviews/' + reviewId + '/video-delete'),
  postFeature: id => http.post('/reviews/' + id + '/feature', {}),
  postUnfeature: id => http.post('/reviews/' + id + '/unfeature', {}),
  postResolve: param =>
    http.post('reviews/' + param.id + '/resolve', {
      body: param.message,
    }),
  postEditReview: param =>
    http.post('/reviews/' + param.id + '/edit-review-text', {
      body: param.message,
    }),
  postCommentReview: param =>
    http.post('/reviews/' + param.id + '/comment', {
      body: param.message,
    }),
  postEditCommentReview: param =>
    http.post('/reviews/' + param.id + '/edit-comment', {
      body: param.message,
    }),
  postEditReviewerName: param =>
    http.post('/reviews/' + param.id + '/edit-reviewer-name', {
      name: param.message,
    }),
  resendVerificationEmail: param =>
    http.post('/resend-verification-email', {
      review_id: param.review_id,
      email: param.email,
    }),
  resendReviewRequest: param =>
    http.post('/resend-review-request', {
      review_id: param.review_id,
    }),
  loadSellerReviews: pagination => {
    const params = {
      start: pagination.rowsPerPage * (pagination.page - 1) || 0,
      length: pagination.rowsPerPage,
      order: pagination.sortBy[0],
      order_direction: pagination.descending ? 'desc' : 'asc',
      search: pagination.search,
      startDate: pagination.startDate ? pagination.startDate : null,
      endDate: pagination.endDate ? pagination.endDate : null,
      source: pagination.source ? pagination.source : null,
      approved: pagination.approved ? pagination.approved : null,
      filterBy: [
        pagination.filterBy ? pagination.filterBy : null,
        pagination.startDate || pagination.endDate ? 'date' : null,
      ]
        .filter(e => !!e)
        .join(','),
      stars: pagination.stars[0] ? JSON.stringify(pagination.stars) : null,
    };
    return http.get('/reviews/shop', { params }).then(res => res.data);
  },
  unpublishReviews: reviews => http.post('unpublish-reviews', { reviews }),
  publishReviews: reviews => http.post('publish-reviews', { reviews }),
  deleteReviews: reviews => http.post('delete-reviews', { reviews }),
  featureReviews: reviews => http.post('feature-reviews', { reviews }),
  unfeatureReviews: reviews => http.post('unfeature-reviews', { reviews }),
  incentivizeReviews: reviews => http.post('incentivize-reviews', { reviews }),
  addCarouselReviews: reviews => http.post('add-carousel-reviews', { reviews }),
  resendEmailReviews: reviews => http.post('resend-verification-email-bulk', { reviews }),
  linkReviewsToProduct(reviews, productId) {
    const data = {
      reviews,
      productId,
    };

    return http.post('link-reviews-to-product', data);
  },
  unlinkReviews: reviews => http.post('unlink-reviews', { reviews }),
  searchProducts(search, product_id_first) {
    const params = {
      search,
      product_id_first,
    };
    return http
      .get('products', {
        params,
      })
      .then(res => res.data);
  },
};
